import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';

  :global(.BasicCRMModal__title) {
    margin-bottom: 5px !important;
  }

  .CrmSendMessageByWazzupForm {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__inputs-inner {
      display: flex;
      width: 100%;
      flex-direction: column;
      gap: 1rem;
    }

    &__sendTo {
      align-self: flex-start;
      font-weight: bold;
      padding-bottom: 1rem;
    }

    &__byWazzup {
      margin-bottom: 20px;
    }
  }
`;

export { staticStyles };
